import { DbRef } from '@caresend/types';
import { getPath } from './path.js';

/**
 * ```
 * `${DbRef.PLACE_GROUPS}/${id}/${childPath}`
 * ```
 */

function getPlaceGroupPath(id, childPath) {
  return getPath(`${DbRef.PLACE_GROUPS}/${id}`, childPath);
}

export { getPlaceGroupPath };
